import { render, staticRenderFns } from "./RightColumn.vue?vue&type=template&id=752c3fa1&"
import script from "./RightColumn.vue?vue&type=script&lang=js&"
export * from "./RightColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports